module.exports = __webpack_public_path__ + "src/assets/img/logotype-white.25995b41.svg";